import { Button } from "@blueprintjs/core"
import styled from "@emotion/styled"

export const SelectButton = styled(Button)({
  width: "250px",
})
